<template>
  <sea-page
    title="Upload documento privacy"
    header="Upload documento privacy"
    showCompanyHeader
    back
  >
    <sea-page-content toolbar hideRapidSearch>
      <template v-slot:toolbar>
        <table-toolbar-button
          icon="mdi-cloud-upload"
          label="Upload"
          @click="save"
          :disabled="$v.editedItem.$invalid"
        ></table-toolbar-button>
      </template>
      <v-card flat>
        <form name="form" role="form" @submit.prevent="save()">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3">
                  <v-text-field
                    v-model="$v.editedItem.dataConsegna.$model"
                    label="Data"
                    type="date"
                    :error-messages="errors('dataConsegna')"
                    @input="$v.editedItem.dataConsegna.$touch()"
                    @blur="$v.editedItem.dataConsegna.$touch()"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3">
                  <v-text-field
                    v-model="$v.editedItem.descrizione.$model"
                    label="Titolo documento"
                    :error-messages="errors('descrizione')"
                    @input="$v.editedItem.descrizione.$touch()"
                    @blur="$v.editedItem.descrizione.$touch()"
                    maxlength="50"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3">
                  <v-file-input
                    @input="$v.editedItem.file.$touch()"
                    @blur="$v.editedItem.file.$touch()"
                    v-model="$v.editedItem.file.$model"
                    :error-messages="errors('file')"
                    label="Allega file"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </form>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { maxLength, required } from "vuelidate/lib/validators";
import mixin from "@/mixin";

export default {
  mixins: [mixin, validationMixin],
  validations() {
    return {
      editedItem: {
        dataConsegna: {
          required,
          minValue(val) {
            return new Date(val) >= new Date(this.today());
          },
        },
        descrizione: {
          required,
          maxLength: maxLength(50),
        },
        file: {
          required,
        },
      },
    };
  },
  data() {
    return {
      editedItem: {
        codAzienda: null,
        descrizione: null,
        nomeFile: null,
        dataConsegna: null,
        file: null,
      },
      overlay: false,
    };
  },
  mounted() {
    this.editedItem.dataConsegna = this.today();
  },
  destroyed() {},
  methods: {
    async save() {
      this.$v.$touch();
      if (!this.$v.editedItem.$invalid) {
        this.overlay = true;
        await this.send(this.editedItem);
        this.overlay = false;
        this.$router.back();
      }
    },
    errors(fieldName) {
      const errors = [];
      if (!this.$v.editedItem[fieldName].$dirty) return errors;
      if (fieldName === "dataConsegna") {
        !this.$v.editedItem.dataConsegna.required &&
          errors.push(this.locales.required);
        !this.$v.editedItem.dataConsegna.minValue &&
          errors.push("La data deve essere maggiore o uguale a quella odierna");
      } else if (fieldName === "descrizione") {
        !this.$v.editedItem.descrizione.required &&
          errors.push(this.locales.required);
      } else if (fieldName === "file") {
        !this.$v.editedItem.file.required && errors.push(this.locales.required);
      }
      return errors;
    },
    ...mapActions({
      send: "docsAzi/uploadPrivacyDocument",
    }),
  },
  computed: {
    ...mapGetters({
      companyId: "docsAzi/currentCompany",
    }),
    cardHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return "220px";
        case "lg":
          return "400px";
        case "xl":
          return "640px";
        default:
          return "640px";
      }
    },
  },
};
</script>

<style>
/* */
</style>
